var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"p-0"},[_c('div',{staticClass:"col-12 p-0 m-0"},[_c('app-tab',{attrs:{"tabs":_vm.tabs,"type":"horizontal"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }